import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Kopeeritud

  <span style="color:#85c1dc;">**FI:**</span>
  Kopioitu

  <span style="color:#85c1dc;">**RU:**</span>
  Скопирована
*/
/* @__NO_SIDE_EFFECTS__ */
const m322 = msg(
  mf`Kopeeritud`,
  mf`Kopioitu`,
  mf`Скопирована`,
)

export { m322 as 'w.wishlist.share.copy.button.confirmation' }